import * as React from 'react';
import { Typography as AntTypography } from 'antd';

type TextProps = {
  // TODO
};

const Text = (props: TextProps & React.ComponentProps<typeof AntTypography.Text>) => {
  const { className } = props;
  const classNames = [className, 'text'];
  return <AntTypography.Text {...props} className={classNames.join(' ')} />;
};

Text.defaultProps = {
  // TODO
};

export default Text;
